import { RefObject, useEffect } from 'react';

function useAnimation(ref: RefObject<HTMLDivElement|null>) {
    useEffect(() => {
        let left = 0;
        let animationFrame: number;
        const callback = () => {
            if (ref.current) {
                left += 1;
                if (left >= 180) {
                    left = 0;
                }
                ref.current.style.transform = `translateX(-${left}px)`;
                animationFrame = requestAnimationFrame(callback);
            }
        };
        animationFrame = requestAnimationFrame(callback);
        return () => {
            cancelAnimationFrame(animationFrame);
        };
    }, [ref]);
}

export default useAnimation;
